export default "__VITE_ASSET__CnTpKdd7__"